export enum SpvDownline {
  are = 'ARE',
  bro = 'BRO',
}
